module.exports = __webpack_public_path__ + "img/Menu.68949ffa.svg";